import { Col, Row } from "react-bootstrap";

import RenderField from "../RenderField";

const Personal = ({ register, errors,rwanda }) => {
  return (
    <div className="w-full px-4 pt-8">
      <Row className="flex justify-end items-end">
        <Col md={6}>
          <RenderField
            name={"names"}
            label={"Full Names"}
            required={true}
            register={register}
            errors={errors}
            maxLength={50}
          />
        </Col>

        <Col md={6}>
          <RenderField
            size={"small"}
            type={"tel"}
            label={"Phone Number"}
            className={"form-control"}
            placeholder={"Tel"}
            name={"phone"}
            required={true}
            register={register}
            errors={errors}
          />
        </Col>

      </Row>
      <Row>
        <Col md={6}>
          <RenderField
            type={"email"}
            name={"email"}
            label={"Email Address"}
            placeholder={"Email"}
            required={true}
            register={register}
            errors={errors}
          />
        </Col>
        <Col md={6}>
          <RenderField
            key={"country"}
            type={rwanda ? "number" : "text"}
            label={rwanda ? "National ID" : "Passport Number"}
            name={"nationalId"}
            required={true}
            register={register}
            errors={errors}
            minLength={rwanda ? 16 : 4}
            maxLength={rwanda ? 16 : 16}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Personal;
